import { createRouter } from '@tanstack/react-router';
import type { AuthContextValue } from './auth/types';
import { routeTree } from './routeTree.gen';

/** Router context carries `auth` so any route's `beforeLoad`/`loader` can read it
 * (see src/routes/_authenticated.tsx's guard). The real value is injected at render
 * time via `<RouterProvider context={{ auth }} />` in main.tsx — `undefined!` here
 * is just the type-level placeholder `createRouter` requires before that happens. */
export const router = createRouter({
  routeTree,
  context: { auth: undefined as unknown as AuthContextValue },
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
